import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { MainLayout } from "@/components/layout";
import { PageLoader } from "@/components/ui";
import { HomePage } from "@/pages/home-page";
import {
  TextToImagePage,
  ImageToVideoPage,
  ExtendVideoPage,
} from "@/pages/create";
import { GeneratePage } from "@/pages/generate-page";
import { AssetsPage } from "@/pages/assets-page";
import { PiecanRedirectPage } from "@/pages/piecan-redirect-page";
import { ExplorePage } from "@/pages/explore-page";
import { FreeGenPage } from "@/pages/free-gen-page";

const BillingPage = lazy(() =>
  import("@/pages/billing-page").then((m) => ({ default: m.BillingPage })),
);
const AffiliatesPage = lazy(() =>
  import("@/pages/affiliates-page").then((m) => ({ default: m.AffiliatesPage })),
);
const SupportPage = lazy(() =>
  import("@/pages/support-page").then((m) => ({ default: m.SupportPage })),
);
const TermsPage = lazy(() =>
  import("@/pages/terms-page").then((m) => ({ default: m.TermsPage })),
);
const PrivacyPage = lazy(() =>
  import("@/pages/privacy-page").then((m) => ({ default: m.PrivacyPage })),
);
const RefundPage = lazy(() =>
  import("@/pages/refund-page").then((m) => ({ default: m.RefundPage })),
);
const AcademyPage = lazy(() =>
  import("@/pages/academy").then((m) => ({ default: m.AcademyPage })),
);
const AcademyPostPage = lazy(() =>
  import("@/pages/academy").then((m) => ({ default: m.AcademyPostPage })),
);

function AppRoutes() {
  return (
    <MainLayout>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/create-character" element={<TextToImagePage />} />
          <Route path="/edit-character" element={<Navigate to="/create-character" replace />} />
          <Route path="/create-scene" element={<Navigate to="/animate-character" replace />} />
          <Route path="/animate-character" element={<ImageToVideoPage />} />
          <Route path="/free-gen" element={<FreeGenPage />} />
          <Route path="/animate-audio" element={<Navigate to="/animate-character" replace />} />
          <Route path="/extend-video" element={<ExtendVideoPage />} />
          <Route path="/create" element={<Navigate to="/create-character" replace />} />
          <Route path="/generation/:id" element={<GeneratePage />} />
          <Route path="/go/piecan" element={<PiecanRedirectPage />} />
          <Route path="/assets" element={<AssetsPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/affiliates" element={<AffiliatesPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/refund-policy" element={<RefundPage />} />
          <Route path="/academy" element={<AcademyPage />} />
          <Route path="/academy/:slug" element={<AcademyPostPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}

export function App() {
  return <AppRoutes />;
}
